import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Decode a folder path from a URL search param.
 * Handles tilde-encoding (~XX → %XX) used by some routing frameworks
 * (e.g., scio1 encodes `/` as `~2F` instead of `%2F`).
 * Safe to call multiple times (idempotent) — only decodes when tilde-encoding is present.
 */
export function decodeFolderPath(raw: string): string {
  // Matches Angular UI Router's valFromString — only two tilde-encodings:
  //   '~2F' → '/'   (encoded slash)
  //   '~~'  → '~'   (escaped tilde)
  // All other chars are already decoded by the browser's searchParams.get().
  // Idempotent: paths starting with '/' are already decoded (Angular-encoded paths
  // start with ~2F). Paths without '~' have nothing to decode.
  if (!raw.includes('~') || raw.startsWith('/')) return raw;
  return raw.replace(/~~|~2F/g, (m) => (m === '~~' ? '~' : '/'));
}
